import React from "react";

function Header() {
  return (
    <div className="flex justify-center p-2">
      <h1 className="font-extrabold tracking-widest text-xl md:text-3xl text-orange-700">Task Tracker</h1>
    </div>
  );
}

export default Header;
